var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 768",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cancelar_svg__st0{fill:#5c5959}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cancelar_svg__st0",
    d: "M534.2 572.7l297.9-314.3c7.6-8 7.2-20.6-.8-28.2-8-7.6-20.6-7.2-28.2.8L505.3 545.3c-7.6 8-7.2 20.6.8 28.2 7.9 7.6 20.5 7.2 28.1-.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cancelar_svg__st0",
    d: "M832.1 545.3L534.2 231c-7.6-8-20.2-8.3-28.2-.8-8 7.6-8.3 20.2-.8 28.2l297.9 314.3c7.6 8 20.2 8.3 28.2.8 8-7.6 8.3-20.2.8-28.2"
  })));
}

export default SvgCancelar;